import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getAtmCompany = (atmCompanyId: number | undefined): Promise<IGetAtmCompany> => {
  return axiosDefaultApi.get(`/api/AtmCompanies/GetAtmCompanyViaID/${atmCompanyId}`);
};

type QueryFnType = typeof getAtmCompany;

type UseGetAtmCompanyOptions = {
  atmCompanyId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAtmCompany = ({ atmCompanyId , config }: UseGetAtmCompanyOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getAtmCompany_${atmCompanyId}`],
    queryFn: () => getAtmCompany(atmCompanyId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Εταιρίας.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};